import * as React from 'react';
import {
    FormGroup,
    ControlLabel,
    InputGroup,
    Button,
    ButtonToolbar,
    FormControl,
    Table
} from 'react-bootstrap';
import ICoordinate from '../ICoordinate';

export class Polygon {
    public Path: ICoordinate[];
    public Draggable: boolean;
    public Editable: boolean;
    public Visible: boolean;

    private intersectionPoint: ICoordinate = null;
    private polygon: google.maps.Polygon = null;
    private onChange: (path: ICoordinate[]) => void;

    constructor(
        path: ICoordinate[],
        draggable: boolean,
        editable: boolean,
        visible: boolean,
        onChange: (path: ICoordinate[]) => void
    ) {
        this.Path = path;
        this.Draggable = draggable;
        this.Editable = editable;
        this.Visible = visible;
        this.onChange = onChange;
    }

    redraw(map: google.maps.Map): void {
        if (this.polygon) {
            this.polygon.setMap(null);
            this.polygon.setMap(map);
        }
    }

    setPath(path: ICoordinate[]) {
        if (this.polygon) {
            this.polygon.setPath(
                path.map((c) => {
                    return { lat: c.latitude, lng: c.longitude };
                })
            );
        }
    }

    setVisible(visible: boolean) {
        if (this.polygon) {
            this.polygon.setVisible(visible);
        }
    }

    hideIfIntersects(coordinate: ICoordinate) {
        if (!this.Path || this.Path.length === 0 || !google.maps || !google.maps.geometry) return;
        let latLng = new google.maps.LatLng(coordinate.latitude, coordinate.longitude);
        let poly = this.polygon;
        if (!poly) {
            poly = new google.maps.Polygon({
                paths: this.Path.map((c) => {
                    return { lat: c.latitude, lng: c.longitude };
                })
            });
        }

        this.Visible = google.maps.geometry.poly.containsLocation(latLng, poly);
    }

    createPolygon(map: google.maps.Map, highlight: boolean, handleClick: () => void) {
        if (!this.Visible || !this.Path || this.Path.length === 0) {
            return;
        }

        let path = this.Path.map((c) => {
            return { lat: c.latitude, lng: c.longitude };
        });
        this.polygon = new google.maps.Polygon({
            map: map,
            strokeColor: highlight ? '#FF0000' : '#0035ff',
            strokeOpacity: 0.4,
            strokeWeight: highlight ? 2 : 1,
            fillColor: highlight ? '#FF0000' : '#0035ff',
            fillOpacity: highlight ? 0.25 : 0.1,
            draggable: this.Draggable,
            editable: this.Editable,
            geodesic: false,
            visible: this.Visible,
            zIndex: highlight ? 500 : null
        });

        this.polygon.setPath(path);

        let eventHandler = (event: any) => {
            this.Path = this.polygon
                .getPath()
                .getArray()
                .map((latLng: google.maps.LatLng) => {
                    return {
                        latitude: latLng.lat(),
                        longitude: latLng.lng()
                    };
                });
            this.onChange(this.Path);
        };

        if (handleClick) {
            this.polygon.addListener('click', handleClick);
        }

        this.polygon.getPath().addListener('insert_at', eventHandler);
        this.polygon.getPath().addListener('remove_at', eventHandler);
        this.polygon.getPath().addListener('set_at', eventHandler);
    }
}

export default Polygon;
